import type {
  ExpenseStructuredData,
  OurWorkStructuredData,
  OutgoingInvoiceData,
} from ".";

type TOurWorkBudgetSplits = OutgoingInvoiceData["ourWorkBudgetSplits"];
type TExpenseBudgetSplits = OutgoingInvoiceData["expenseBudgetSplits"];
type TOurWorkBudgetItem = OurWorkStructuredData["budgetItems"][0];
type TExpenseBudgetItem = ExpenseStructuredData["budgetItems"][0];

export class OurWorkStructured {
  id: OurWorkStructuredData["id"];
  name: OurWorkStructuredData["name"];
  budgetItemsWithSplit: [TOurWorkBudgetItem, TOurWorkBudgetSplits[0]][];

  constructor(structured: OurWorkStructuredData, splits: TOurWorkBudgetSplits) {
    this.id = structured.id;
    this.name = structured.name;
    this.budgetItemsWithSplit = structured.budgetItems.flatMap((item) => {
      const split = splits.find((s) => s.our_work_budget_item_id === item.id);
      return split ? [[item, split]] : [];
    });
  }

  get isEmpty() {
    return this.budgetItemsWithSplit.length === 0;
  }
}

export class ExpenseStructured {
  id: ExpenseStructuredData["id"];
  name: ExpenseStructuredData["name"];
  budgetItemsWithSplit: [TExpenseBudgetItem, TExpenseBudgetSplits[0]][];

  constructor(structured: ExpenseStructuredData, splits: TExpenseBudgetSplits) {
    this.id = structured.id;
    this.name = structured.name;
    this.budgetItemsWithSplit = structured.budgetItems.flatMap((item) => {
      const split = splits.find((s) => s.expense_budget_item_id === item.id);
      return split ? [[item, split]] : [];
    });
  }

  get isEmpty() {
    return this.budgetItemsWithSplit.length === 0;
  }
}
